import React from 'react';
import { Placeholder } from 'cw-ui-core';

const Shimmer = ({ isLoading, children, shimmerClassName }) => {
    return <>{isLoading ? <Placeholder className={shimmerClassName} /> : children}</>;
};

export default Shimmer;
